<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<SearchAlertSection :query="q" :users="users" @search="searchMatters($event)" />
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="matters"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openDialog(item)">
							<td>{{ item.alert_type }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.status_i18n }}</td>
							<td>{{ item.order_number }}</td>
							<td>{{ item.team_member_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<AlertShowDialog
			:dialog.sync="dialog"
			:id="selectedItem.id"
			:alert_type="selectedItem.alert_type"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import SearchAlertSection from "./components/SearchAlertSection.vue"
import AlertShowDialog from "./components/AlertShowDialog.vue"

export default {
	components: {
		CommonFlame,
		PaginationModule,
		SearchAlertSection,
		AlertShowDialog,
	},
	data() {
		return {
			title: "アラート一覧",
			matters: [],
			users: [],
			selectedItem: {},
			dialog: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
			},
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
			this.fetchMatters(this.q, page, true)
	},
	methods: {
		fetchMatters(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/sales/alerts", {
					params,
					headers,
				})
				.then((res) => {
					this.matters = this.setMatters(res.data.matters)
					this.pagination = res.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.users = res.data.users
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setMatters(matters) {
			// TODO ここでデータを整形する 現在はテストデータ
			const statuses = ["見積提出済み", "未受注", "受注済み", "製造中", "出荷済み", "計上済み"]
			const alert_types = [
				"承認予定日超過",
				"出荷日間近納入先未入力",
				"書類不揃い",
				"納期間近未受注",
			]
			return matters.map((matter) => {
				matter.alert_type = alert_types[Math.floor(Math.random() * alert_types.length)]
				matter.status_i18n = statuses[Math.floor(Math.random() * statuses.length)]
				return matter
			})
		},
		openDialog(item) {
			this.selectedItem = item
			this.dialog = true
		},
		getPage(page) {
			this.fetchMatters(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},

		searchMatters(q) {
			this.q = q
			this.fetchMatters(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{ text: "種類", value: "alert_type", width: "120px" },
		{ text: "案件名", value: "name", width: "150px" },
		{ text: "状態", value: "status_i18n", width: "200px" },
		{ text: "受注番号", value: "order_number", width: "200px" },
		{ text: "営業担当者", value: "team_member_name", width: "120px" },
	]
}
</script>